import { render, staticRenderFns } from "./ban_function.vue?vue&type=template&id=ca86ddde&scoped=true"
import script from "./ban_function.vue?vue&type=script&lang=js"
export * from "./ban_function.vue?vue&type=script&lang=js"
import style0 from "./ban_function.vue?vue&type=style&index=0&id=ca86ddde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca86ddde",
  null
  
)

export default component.exports